import * as R from "ramda";

import { all, spawn } from "redux-saga/effects";

import globalModule from "./modules/global";

const rootSaga = function*() {
  const modulesSagas = R.pipe(
    R.map(R.prop("sagas")),
    R.filter(R.complement(R.isNil)),
    R.flatten
  )(globalModule.all);

  yield all(modulesSagas.map(saga => spawn(saga)));
};

export default rootSaga;
